import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  const requiredRoles = route.data['roles'] as string[];
  const requiredPermissions = route.data['permissions'] as string[];

  // Check roles if specified
  if (requiredRoles && requiredRoles.length > 0) {
    if (!auth.hasAnyRole(requiredRoles)) {
      router.navigate(['/dashboard']); // Redirect to dashboard if no access
      return false;
    }
  }

  // Check permissions if specified
  if (requiredPermissions && requiredPermissions.length > 0) {
    if (!auth.hasAnyPermission(requiredPermissions)) {
      router.navigate(['/dashboard']); // Redirect to dashboard if no access
      return false;
    }
  }

  return true;
};

// Specific role guards for convenience
export const hrAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  if (!auth.hasRole(AuthService.ROLES.HR_ADMIN)) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};

export const managerGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  if (!auth.hasAnyRole([AuthService.ROLES.HR_ADMIN, AuthService.ROLES.MANAGER])) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
